// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/macrosAttr/style.scss
 ** module id = 415
 ** module chunks = 1
 **/